<template>
  <div class="materials-audit">
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="small"
        label-width="98px"
        :model="filter"
        inline
      >
        <el-form-item label="关联教务服务方">
          <el-input v-model="filter.agentName" placeholder="" clearable />
        </el-form-item>
        <el-form-item label="关联招生服务方">
          <el-input v-model="filter.distributionName" placeholder="" clearable />
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            v-model="applyDate"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="申请状态">
          <el-select
            style="width: 188px"
            v-model="filter.materialsAuditStatus"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1" />
            <el-option label="审核中" :value="1" />
            <el-option label="审核通过" :value="2" />
            <el-option label="驳回" :value="3" />
            <el-option label="不需要审核" :value="9" />
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 50px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <el-table border v-loading="loading" :data="list" style="width:100%;margin-top:10px">
        <el-table-column label="关联教务服务方" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.agentName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="关联招生服务方" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.distributionName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.materialsAuditStatus === 1">审核中</span>
            <span v-else-if="row.materialsAuditStatus === 2">审核通过</span>
            <span v-else-if="row.materialsAuditStatus === 3">驳回</span>
            <span v-else-if="row.materialsAuditStatus === 9">不需要审核</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column label="学员姓名" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学员手机号" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.phone || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="证件类型" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.type == 1">身份证</span>
            <span v-else-if="row.type == 2">港澳台身份证</span>
            <span v-else-if="row.type == 3">港澳台通行证</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column label="证件号码" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.cardNo || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="applyDate" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核人" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.auditorName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="108" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="toViewDetail(row)">查看材料</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 参训审核材料 -->
    <MaterialsInfo ref="materialsInfoRef" />
  </div>
</template>

<script>
import MaterialsInfo from '@/views/orderAdmin/components/materials.vue'
import { userMaterialsPage } from '@/api/orderAdmin/orderList'
import { processing } from "@/utils/handle.js";

export default {
  name: 'MaterialsAudit',

  components: { MaterialsInfo },
  data() {
    return {
      filter: {
        agentName: '',
        distributionName: '',
        timeStart: '',
        timeEnd: '',
        materialsAuditStatus: '-1',
        page: 1,
        limit: 10
      },
      applyDate: [],
      loading: false,
      total: 0,
      list: []
    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    // 搜索
    handleSearch() {
      this.filter.page = 1
      this.handleGetListPage()
    },
    // 重置
    handleReset() {
      this.filter = this.$options.data().filter
      this.applyDate = []
      this.total = 0
      this.list = []
      this.handleGetListPage()
    },
    handleGetListPage () {
      if (this.applyDate && this.applyDate.length !== 0)  {
        this.filter.timeStart = this.applyDate[0]
        this.filter.timeEnd = this.applyDate[1]
      }
      const params = processing(this.filter)
      this.loading = true
      userMaterialsPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.list = data.records
          this.total = +data.total
        }
      }).finally(() => {
        this.loading = false
      })
    },
    toViewDetail (row) {
      this.$refs.materialsInfoRef.init({
        infoId: row.id,
        materialsAuditStatus: row.materialsAuditStatus,
        applyMaterials: row.applyMaterials
      })
    }
  }
}
</script>

<style>

</style>
